<template>
    <div class="container">
        <div class="row">
            <h3>Service Selection</h3>
            Ameriflex offers a full suite of benefits payments solutions. To add or remove services please choose from the options below. Changes will be reviewed by Ameriflex prior to proceeding.
        </div>
        <div class="row">
            <table class="table table-hover table-sm mt-3 table-accounts">
                <thead>
                    <th>Description</th>
                    <th>Selected</th>
                </thead>
                <tbody>
                    <tr v-for="(s, index) in serviceTypes" :key="index">
                        <td>{{ s.description }}</td>
                        <td>
                            <input type="checkbox" v-model="s.selected" :disabled="isDisabled(s)" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['items'],
        data() {
            return {
                title: 'Services',
                serviceTypes: []
            }
        },
        async created() {
            let result = await romeApi.get('config/product-definition');
            this.serviceTypes = result.map(s => {
                let service = {
                    orderFormCode: s.orderFormCode,
                    description: s.description,
                    selected: this.items.find(i => i.item == s.orderFormCode) != null
                }
                return service;
            });
        },
        methods: {
            async save() {
                let services = this.serviceTypes.filter(x => x.selected)
                    .map(s => s.orderFormCode);

                if(services && services.length > 0) {
                    return services;
                }
                else {
                    toastService.error('Please select at least one service');
                    return false;
                }
            },
            isDisabled(item) {
                var selectedServices = this.serviceTypes.filter(x => x.selected).map(x => x.orderFormCode);
                return orderFormItemDisabled(selectedServices, item.orderFormCode);
            }
        }
    }

    export function orderFormItemDisabled(selectedServices, orderFormCode) {
        if(orderFormCode == "TEL" && selectedServices.includes("TELP"))
            return true;
        if(orderFormCode == "TELP" && selectedServices.includes("TEL"))
            return true;

        return false;
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/employer/OrderServices.vue